export default __webpack_public_path__ + "static/sport-0c0635b994e4906088c87918257f796c.webp";